import { render } from "./cart-confirmation-modules.vue?vue&type=template&id=ae97a794&scoped=true"
import script from "./cart-confirmation-modules.vue?vue&type=script&lang=js"
export * from "./cart-confirmation-modules.vue?vue&type=script&lang=js"

import "./cart-confirmation-modules.vue?vue&type=style&index=0&id=ae97a794&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae97a794"]])

export default __exports__